module.exports = __webpack_public_path__ + "img/hr-red-asterisk-07.966089c4.png";